
/* eslint-disable camelcase */
import NrBar from '@nextrequestco/components/src/components/NrBar/NrBar.vue'
import NrCard from '@nextrequestco/components/src/components/NrCard/NrCard.vue'
import NrIcon from '@nextrequestco/components/src/components/NrIcon/NrIcon.vue'
import NrTag from '@nextrequestco/components/src/components/NrTag/NrTag.vue'
import { mapActions, mapState } from 'vuex'
import {
  DocumentSeverity,
  humanizedSeverityStatus,
  severityStatusColor,
  severityStatusBgColor
} from '../../admin/document_severity_status'
import {
  DocumentReviewStatus,
  humanizedReviewStatus,
  reviewStatusColor,
  reviewStatusBgColor
} from '../../admin/document_review_status'

export default {
  name: 'RiskReport',
  components: {
    NrBar,
    NrCard,
    NrIcon,
    'nr-tag': NrTag
  },
  props: {
    documents: {
      type: Array,
      default: () => []
    },
    filterParams: {
      type: Object,
      default: () => ({})
    },
    selectAll: {
      type: Boolean,
      default: () => false
    }
  },
  mounted() {
    if (this.selectAll) {
      this.fetchRequestDocumentRisk(this.filterParams)
    }
  },
  data() {
    return {
      isOpen: true
    }
  },
  computed: {
    ...mapState('request_show', ['request', 'requestDocumentRisk']),
    documentRiskCounts() {
      return {
        high: this.requestDocumentRisk.high_severity || 0,
        medium: this.requestDocumentRisk.medium_severity || 0,
        low: this.requestDocumentRisk.low_severity || 0,
        na: this.requestDocumentRisk.unscannable || 0,
        pending:
          (this.requestDocumentRisk.total_documents || 0) -
          (this.requestDocumentRisk.total_scanned || 0),
        reviewed: this.requestDocumentRisk.reviewed || 0,
        needs_review: this.requestDocumentRisk.needs_review || 0
      }
    },
    severityData() {
      const severities: (DocumentSeverity | null)[] = [
        'high',
        'medium',
        'low',
        'na',
        null
      ]
      return severities.map((severity) => {
        let value
        if (this.selectAll) {
          value = this.documentRiskCounts[severity || 'pending']
        } else {
          value = this.documents.filter(
            ({ document_scan: { severity: docSeverity } }) =>
              docSeverity === severity
          ).length
        }
        return {
          label: humanizedSeverityStatus(severity),
          color: severityStatusBgColor(severity),
          active_color: severityStatusColor(severity),
          value
        }
      })
    },
    reviewStatusData() {
      const reviewed = this.documents.filter(
        ({ document_scan: { review_status } }) => review_status === 'reviewed'
      ).length
      const statuses: DocumentReviewStatus[] = ['needs_review', 'reviewed']
      return statuses.map((status) => {
        let value
        if (this.selectAll) {
          value = this.documentRiskCounts[status] || 0
        } else {
          value =
            status === 'reviewed' ? reviewed : this.documents.length - reviewed
        }
        return {
          label: humanizedReviewStatus(status),
          color: reviewStatusBgColor(status),
          active_color: reviewStatusColor(status),
          value
        }
      })
    }
  },
  methods: {
    ...mapActions('request_show', ['fetchRequestDocumentRisk']),
    toggleOpen() {
      this.isOpen = !this.isOpen
    }
  }
}
